import { createSlice } from '@reduxjs/toolkit';
import { loginAPI } from '../../service/authService';
import toast from 'react-hot-toast';
import { Navigate } from 'react-router-dom';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLoading: false,
        authData: JSON.parse(sessionStorage.getItem('authData')),
        Token: JSON.parse(sessionStorage.getItem('token')),
        isLoggedIn: JSON.parse(sessionStorage.getItem('isLoggedIn')) === null ? false : true,
        error: null
    },
    reducers: {
        setLoading: (state) => {
            state.isLoading = true;
        },
        handleSuccessLogin: (state, action) => {
            state.isLoading = false;
            state.authData = action.payload?.data;
            state.isLoggedIn = true;
            state.Token = `Bearer ${action.payload?.token?.access}`;
            sessionStorage.setItem('authData', JSON.stringify(action.payload?.data));
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.setItem('accessToken', JSON.stringify(`Bearer ${action.payload?.token?.access}`));
        },
        handleErrorLogin: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        handleLogout: (state) => {
            state.isLoading = false;
            state.error = null;
            state.authData = null;
            state.isLoggedIn = false;
            sessionStorage.clear();
        },
        handleResetAuth: (state) => {
            state.isLoading = false;
            state.error = null;
        },
        handleUnAuthorizeRequest: (state) => {
            state.authData = null;
            state.isLoggedIn = false;
            state.Token = null;
            sessionStorage.clear();
            state.isLoading = false;
        }
    }
});

export const { setLoading, handleSuccessLogin, handleErrorLogin, handleLogout, handleResetAuth, handleUnAuthorizeRequest } = authSlice.actions;
export default authSlice.reducer;

export const authLoginApi = (authLoginData) => async (dispatch) => {
    dispatch(setLoading());
    try {
        const { data } = await loginAPI(authLoginData);
        const { statusCode } = data;

        if (statusCode === 200) {
            dispatch(handleSuccessLogin(data));
        }
    } catch (error) {
        if (error.response && error.response.data.errors) {
            return dispatch(handleErrorLogin(error.response.data.errors));
        } else {
            return dispatch(handleErrorLogin(error.message));
        }
    }
};
export const handleUnAuthorizeUserRequest = () => (dispatch) => {
    <Navigate replace to={'/login'} />;
    dispatch(handleUnAuthorizeRequest());
    toast('Your token has been expired!', {
        icon: '⚠️'
    });
};
